import { Injectable } from '@angular/core';
import * as ExcelJS from 'exceljs';

@Injectable({
  providedIn: 'root'
})
export class ExcelService {

  readExcel(evt: any, cb: any) {
    const target: DataTransfer = (evt.target) as DataTransfer;
    if (target.files.length !== 1) {
      return;
    } else {
      const reader: FileReader = new FileReader();
      reader.onload = async (e: any) => {
        const data = e.target.result;
        const workbook = new ExcelJS.Workbook();
        await workbook.xlsx.load(data);
        const worksheet = workbook.getWorksheet(1);
        const jsonData: any[] = [];
        worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
          if (rowNumber > 1) {
            const rowData: any = {};
            worksheet.getRow(1).eachCell((headerCell, colNumber) => {
              const key = headerCell.value as string;
              rowData[key] = row.getCell(colNumber).value;
            });
            jsonData.push(rowData);
          }
        });
        cb(jsonData);
      };
      reader.readAsArrayBuffer(target.files[0]);
    }
  }

  async exportAsExcelFile(json: any[], excelFileName: string): Promise<void> {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('data');
    
    if (json.length > 0) {
      worksheet.columns = Object.keys(json[0]).map(key => ({
        header: key,
        key: key,
        width: 15
      }));
      
      json.forEach(row => {
        worksheet.addRow(row);
      });
    }
    
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = excelFileName + '.xlsx';
    link.click();
    window.URL.revokeObjectURL(url);
  }
}
